"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { getWorkspaceBySubdomain } from "@/server-actions/workspaces/actions";

const DynamicFavicon = ({ workspaceFavicon }) => {
  const [favicon, setFavicon] = useState("/favicon.ico");
  const [previousFavicon, setPreviousFavicon] = useState(null);
  const searchParams = useSearchParams();
  const subdomain = searchParams.get("subdomain");

  useEffect(() => {
    const updateFavicon = async () => {
      if (workspaceFavicon) {
        setFavicon(workspaceFavicon);
      } else if (subdomain) {
        try {
          const result = await getWorkspaceBySubdomain(subdomain);
          if (result.success && result.workspace.favicon) {
            setFavicon(result.workspace.favicon);
          }
        } catch (error) {
          console.error("Error fetching workspace favicon:", error);
        }
      }
    };

    updateFavicon();
  }, [workspaceFavicon, subdomain]);

  useEffect(() => {
    // Skip the initial render
    if (previousFavicon === null) {
      setPreviousFavicon(favicon);
      return;
    }

    // If favicon has changed (not on initial load)
    if (previousFavicon !== favicon) {
      // Find existing favicon elements
      const existingFavicons = document.querySelectorAll(
        'link[rel="icon"], link[rel="shortcut icon"]'
      );

      // Remove any existing favicons
      existingFavicons.forEach((favicon) => favicon.remove());

      // Create and append new favicon
      const link = document.createElement("link");
      link.rel = "icon";
      link.href = favicon;
      document.head.appendChild(link);

      // Add 16x16 and 32x32 sizes if using default favicon
      if (favicon === "/favicon.ico") {
        const sizes = ["16x16", "32x32"];
        sizes.forEach((size) => {
          const sizeLink = document.createElement("link");
          sizeLink.rel = "icon";
          sizeLink.type = "image/png";
          sizeLink.sizes = size;
          sizeLink.href = `/favicon-${size}.png`;
          document.head.appendChild(sizeLink);
        });
      }

      // Update previous favicon
      setPreviousFavicon(favicon);
    }
  }, [favicon, previousFavicon]);

  // This component doesn't render anything
  return null;
};

export default DynamicFavicon;
